import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ee71b74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-[60px] w-[100%] company-wrap index-news" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "flex items-center max-[750px]:justify-between" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "ml-[8px]" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-jiantou_qiehuanzuo" }, null, -1))
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "new-list flex h-[600px] relative z-10" }
const _hoisted_9 = { class: "flex-1 text-white flex pl-[100px] flex-col justify-center" }
const _hoisted_10 = { class: "text-[26px] font-bold mb-[16px] leading-[26px]" }
const _hoisted_11 = { class: "text-[20px] mb-[16px] leading-[20px]" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block w-[100px] h-[10px] bg-white" }, null, -1))
const _hoisted_13 = { class: "new-swiper-wrap !pt-[54px] rounded-sm" }
const _hoisted_14 = {
  key: 0,
  class: "page-turning mr-[12px]"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-xiangxiajiantou" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-xiangxiajiantou" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "list-wrap mr-[35px]" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "bg-white w-[584px] p-[20px] left-wrap flex" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-yuanquan point mr-[4px] flex-shrink-0 !text-[20px] mt-[-7px]" }, null, -1))
const _hoisted_23 = { class: "news-box flex-1" }
const _hoisted_24 = { class: "new-title text-[15px] leading-[15px] text-[#333333] flex items-center" }
const _hoisted_25 = { class: "flex-1 w-[534px] pr-[8px] whitespace-nowrap text-ellipsis overflow-hidden" }
const _hoisted_26 = { class: "text-[12px] text-[#666666] date-span" }
const _hoisted_27 = { class: "new-content w-[534px] text-[13px] text-[#666666] leading-[22px] mt-[8px]" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right-row w-[60px] h-[100%] invisible flex-shrink-0 pt-[10px] pl-[15px]" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-xiangyou-jiantou !text-[24px]" })
], -1))

import { ref, computed, watch, onMounted } from "vue";
import { chunk } from "lodash";
import useGetNewsNavList from "@/hooks/useGetNewsNavList";
import useNavigation from "@/hooks/useNavigation";
import { getPage } from "@/http/api";
interface IList {
  id: number;
  logo: string;
  icon?: string;
  title: string;
  englistName: string;
  children?: Array<IItem>;
}
interface IItem {
  title: string;
  desc: string;
  date: string;
  id: string | number;
  type: string;
}
interface IResult {
  data: Array<IList>;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyActive',
  setup(__props) {

const { push } = useNavigation();
function goNews() {
  push("/news");
}
const activeIndex = ref(0);
const list = ref<Array<IList>>([]);
const curList = computed(() => {
  return chunk(list.value[activeIndex.value].children || [], 4);
});

const current = ref(0);
const changePage = (num: number) => {
  if (current.value + num < 0 || current.value + num >= curList.value.length) {
    return;
  }
  current.value += num;
};
const iconName = computed(() => {
  return function (item: IList, index) {
    if (item.icon) {
      return item.icon;
    } else {
      return ["icon-guangbo", "icon-xinwen_o", "icon-xinxi"][index] || "";
    }
  };
});
// 如果顶部的tab修改了，重置下分页
watch(
  () => activeIndex.value,
  () => {
    current.value = 0;
  }
);
function pullData(res) {
  console.log(res, "res=====");
  list.value = res.data.leftList || [];
  if (!list.value.length) return;
  getSelPage(list.value[0].id, 1);
}
const { getNewsInfo } = useGetNewsNavList("/news", pullData);
onMounted(() => {
  getNewsInfo();
});
function getSelPage(menuId, pageNum) {
  getPage<IResult>({
    menuId,
    pageNum,
    pageSize: 20,
  }).then((res) => {
    list.value[activeIndex.value].children = (res.rows as any) || [];
  });
}
function goNewsDetail(item: IItem) {
  push({
    path: "/news/detail",
    query: {
      id: item.id,
    },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: _normalizeClass(["list-item", activeIndex.value === index ? 'active' : '']),
            onClick: ($event: any) => {
            activeIndex.value = index;
            getSelPage(item.id, 1);
          }
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(['iconfont !text-[32px]', iconName.value(item, index)])
            }, null, 2),
            _createElementVNode("span", _hoisted_5, _toDisplayString(item.title), 1)
          ], 10, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", {
        class: "more-span cursor-pointer relative",
        onClick: goNews
      }, [
        _createTextVNode(" 查看更多"),
        _hoisted_6
      ])
    ]),
    (list.value[activeIndex.value])
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "content w-[100%] box-border",
          style: _normalizeStyle(`--active-index: ${activeIndex.value}`)
        }, [
          _createElementVNode("img", {
            class: "absolute w-[100%] top-[100px] rounded-xl h-[420px] object-cover",
            src: list.value[activeIndex.value].logo
          }, null, 8, _hoisted_7),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(list.value[activeIndex.value].title), 1),
              _createElementVNode("span", _hoisted_11, _toDisplayString(list.value[activeIndex.value].englistName), 1),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              ((curList.value[current.value] || []).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("span", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (changePage(-1))),
                      class: _normalizeClass([current.value === 0 ? 'disabled' : '', "top-arrow"])
                    }, _hoisted_16, 2),
                    _createElementVNode("span", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (changePage(1))),
                      class: _normalizeClass(current.value === curList.value.length - 1 ? 'disabled' : '')
                    }, _hoisted_18, 2)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curList.value[current.value], (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["list-li flex", { 'mb-[20px]': index <= curList.value.length }]),
                    key: item.id,
                    onClick: ($event: any) => (goNewsDetail(item))
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(item.title), 1),
                          _createElementVNode("span", _hoisted_26, _toDisplayString(item.date), 1)
                        ]),
                        _createElementVNode("p", _hoisted_27, _toDisplayString(item.title), 1)
                      ])
                    ]),
                    _hoisted_28
                  ], 10, _hoisted_20))
                }), 128))
              ])
            ])
          ])
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})